import React from 'react';
import './Heading.css';

const TAG_DEFAULTS = {
  display: 'h1',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  label: 'span',
};

function Heading({
  level = 'h1',
  as,
  className = '',
  children,
  ...rest
}) {
  const Tag = as || TAG_DEFAULTS[level] || 'h1';
  const classes = ['ui-heading', `ui-heading--${level}`, className].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}

export default Heading;
